export default "__VITE_ASSET__82e2999d__"